<div class="dialog-page-container">
    <div class="dialog-header  padding-header">
        <div class="display-flex">
            <div class="float-left">
                <h2>Submit a Request</h2>
            </div>
            <div class="float-right">
                <span class="close-dialog" (click)="onCancel()"><img src="../../../assets/icons/icon-close.png"
                        alt="Close" width="16" /></span>
            </div>
        </div>
        <!-- <h3>Submit a Request</h3>
        <button mat-icon-button class="close-btn" (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button> -->
    </div>

    <mat-dialog-content class="dialog-content">
        <div class="padding-content">
            <p>Please fill out the form below to submit your request.</p>
            <form [formGroup]="requestForm">
                <div class="form-field">
                    <div class="field-label">Entry Type <span class="required">*</span></div>
                    <app-select formControlName="type"
                        [field]="{ label: 'Entry Type', options: requestTypes }"></app-select>
                    <mat-error *ngIf="requestForm.get('type')?.hasError('required')">
                        Request type is required
                    </mat-error>
                </div>

                <div class="form-field">
                    <div class="field-label">Choose Requestor <span class="required">*</span></div>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput formControlName="requestor" placeholder="Search requestor..."
                            [matAutocomplete]="requestorAuto" (keypress)="preventSpecialChars($event)">
                        <mat-autocomplete #requestorAuto="matAutocomplete" [displayWith]="displayUser">
                            <mat-option *ngIf="noResultsFound" disabled>
                                No records found
                            </mat-option>
                            <mat-option *ngFor="let user of filteredUsers" [value]="user">
                                {{ user.display_name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="requestForm.get('requestor')?.hasError('required')">
                            Requestor is required
                        </mat-error>
                        <mat-error *ngIf="requestForm.get('requestor')?.hasError('invalidRequestor')">
                            Please select a valid requestor from the list
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field">
                    <div class="field-label">Description <span class="required">*</span></div>
                    <mat-form-field appearance="outline" class="full-width"
                        [class.description-invalid]="requestForm.get('description')?.hasError('maxlength')">
                        <textarea matInput formControlName="description" placeholder="Enter Description here" rows="3"
                            maxlength="2000"
                            (input)="requestForm.get('description')?.markAsTouched()"></textarea>
                        <mat-hint align="end" *ngIf="requestForm.get('type')?.value === 'enhancements'">
                            {{ requestForm.get('description')?.value?.length || 0 }}/300
                        </mat-hint>
                        <mat-error *ngIf="requestForm.get('description')?.hasError('required')">
                            Description is required
                        </mat-error>
                        <mat-error *ngIf="requestForm.get('description')?.hasError('minlength')">
                            Description must be at least 10 characters
                        </mat-error>
                        <mat-error *ngIf="requestForm.get('description')?.hasError('maxlength')">
                            Enhancement description cannot exceed 300 characters
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field">
                    <div class="field-label">
                        Attachments
                        <span class="file-note">(Max file size: 5MB per file)</span>
                        <label for="file-upload" class="input-icon-sm" *ngIf="isFileUplaodEnabled"
                            style="cursor:pointer;">
                            <img src="../../../assets/images/file-upload.svg" alt="Upload Icon" class="icon">
                            <input id="file-upload" type="file" multiple
                                accept=".pdf,.ppt,.pptx,.xlsx,.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp"
                                (change)="onFileSelected($event)" style="display:none">
                        </label>
                    </div>
                    <!-- <div class="file-upload-section">
                        <label for="file-upload" class="input-icon-sm" *ngIf="isFileUplaodEnabled">                            
                            <input id="file-upload" type="file" multiple
                                accept=".pdf,.ppt,.pptx,.xlsx,.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp"
                                (change)="onFileSelected($event)" onclick="this.value = null">
                        </label>
                    </div> -->

                    <!-- Selected Files List -->
                    <div *ngIf="selectedFilesDisplay.length > 0" class="uploaded-file-display">
                        <div class="files-header">
                            <span class="files-count">{{ selectedFilesDisplay.length }} file(s) selected</span>
                            <button type="button" class="clear-all-btn" (click)="clearSelectedFileInput()"
                                aria-label="Clear all files">
                                Clear All
                            </button>
                        </div>
                        <div class="file-attachment-display"
                            *ngFor="let fileData of selectedFilesDisplay; let i = index">
                            <span class="file-name">{{ fileData.name }}</span>
                            <button type="button" class="close" (click)="removeFile(i)" (keydown.enter)="removeFile(i)"
                                (keydown.space)="removeFile(i)" aria-label="Remove file">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
        <button mat-button type="button" (click)="onCancel()" [disabled]="isSubmitting" class="cancel-btn">
            Cancel
        </button>
        <button mat-raised-button type="button" color="primary" (click)="onSubmit()"
            [disabled]="isSubmitting || requestForm.invalid" class="submit-btn">
            <mat-icon *ngIf="isSubmitting" class="spinner">hourglass_empty</mat-icon>
            {{ isSubmitting ? 'Submitting...' : 'Submit Request' }}
        </button>
    </mat-dialog-actions>
</div>